import { useEffect, useState } from "react";
import { http } from "../api";
import { Trophy, Users, TrendingUp, MapPin, Compass, Flame } from "lucide-react";

export default function LeaderboardTV() {
  const [data, setData] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const load = () => http.get("/leaderboard/live").then((r) => { setData(r.data); setTick((t) => t + 1); });
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const now = new Date();

  return (
    <div className="tv-page">
      <header className="tv-head">
        <div className="tv-brand"><div className="mark">84</div><div><b>Nabadwip · Ward 7</b><small>{now.toLocaleDateString("en-GB", { weekday: "long", day: "2-digit", month: "long" })}</small></div></div>
        <div className="tv-clock"><b data-testid="tv-clock">{now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}</b><small>updated · {tick} refresh</small></div>
      </header>

      <div className="tv-stats">
        <div className="tv-stat" data-testid="tv-stat-visits"><Compass /><b>{data?.stats.visits_today ?? "—"}</b><span>Visits today</span></div>
        <div className="tv-stat" data-testid="tv-stat-solved"><TrendingUp /><b>{data?.stats.solved_today ?? "—"}</b><span>Solved today</span></div>
        <div className="tv-stat" data-testid="tv-stat-turnout"><Users /><b>{data?.stats.turnout_pct ?? 0}%</b><span>Turnout · {data?.stats.turnout_voted ?? 0}/{data?.stats.turnout_total ?? 0}</span></div>
        <div className="tv-stat" data-testid="tv-stat-booths"><MapPin /><b>{data?.top_booths.length ?? 0}</b><span>Booths active</span></div>
      </div>

      <div className="tv-body">
        <section className="tv-panel">
          <div className="tv-panel-head"><Trophy size={28} /><b>Top karyakartas</b></div>
          <ol className="tv-list">
            {data?.volunteers.slice(0, 8).map((v, i) => (
              <li key={v.volunteer_id} className={`tv-vol tv-rank-${i}`} data-testid={`tv-vol-${i}`}>
                <span className="tv-rank">#{i + 1}</span>
                <span className="tv-avatar">{v.name.split(" ").map((x) => x[0]).join("")}</span>
                <div className="tv-vol-info">
                  <b>{v.name}</b><small>{v.role} · Booth {v.booth}</small>
                </div>
                <div className="tv-points"><b>{v.points}</b><small>pts</small></div>
                {i === 0 && <Flame size={22} className="tv-crown" />}
              </li>
            ))}
          </ol>
        </section>

        <section className="tv-panel">
          <div className="tv-panel-head"><MapPin size={28} /><b>Top booths</b></div>
          <div className="tv-booths">
            {data?.top_booths.map((b, i) => (
              <div key={b.booth} className="tv-booth" data-testid={`tv-booth-${i}`}>
                <b>Booth {b.booth}</b>
                <span>{b.visits} visits</span>
              </div>
            ))}
          </div>
        </section>
      </div>

      <footer className="tv-foot">
        Auto-refresh every 30s · Ward 7 · Constituency 84 – Nabadwip AC
      </footer>
    </div>
  );
}
